export default "__VITE_ASSET__DI$GmDvM__"